import { useCallback } from "react";
import { IOption } from "../../types/Option";

export const useSelectFilterSort = () => {
  const filterSort = useCallback(
    (optionA: IOption, optionB: IOption): number =>
      (optionA?.label ?? "")
        .toLowerCase()
        .localeCompare((optionB?.label ?? "").toLowerCase()),
    [],
  );

  return { filterSort };
};
